import React, { useEffect, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Footer from "../components/Frontend/Footer/Footer";
import SidebarNav from "../components/Navigation/SideBarNav";
import NavTop from "../components/Navigation/NavTop";
import "./ClientLayoutV2.css"
import FloatingButtonWithPopup from "../components/Frontend/uiUtils/ChatboxWrapper/FloatingButtonWithPopup";

const ClientLayoutV2 = () => {
  const location = useLocation();
  const path = location.pathname;
  const [show_footer, showFooter] = useState(true);

  useEffect(() => {
    // Check URL path and set the expanded state
    if (location.pathname.indexOf("ai_assistant") !== -1) {
      showFooter(false);
    } else {
      showFooter(true);
    }
  }, [location.pathname]);

  return (
    <>
      <NavTop/>
      <div className="client-layout-main-layout">
        <SidebarNav />
     
          <div className="client-layout-main-layout-content">
         {!path.includes("ai_assistant_2")&& <FloatingButtonWithPopup />}
              <Outlet />
            
          </div>
       
      </div>

      {show_footer && <Footer />}
    </>
  );
};

export default ClientLayoutV2;
